import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class AddressInput extends Component {
  constructor(props) {
    super(props);

    this.onStreetAddressChange = this.onStreetAddressChange.bind(this);
    this.onCityChange = this.onCityChange.bind(this);
    this.onStateChange = this.onStateChange.bind(this);
    this.onCountryChange = this.onCountryChange.bind(this);
    this.onPostalCodeChange = this.onPostalCodeChange.bind(this);

    const { value = {} } = props;

    this.state = {
      value: {
        streetAddress: value.streetAddress || '',
        city: value.city || '',
        state: value.state || '',
        country: value.country || '',
        postalCode: value.postalCode || '',
      },
    }
  }

  updateValue(value) {
    this.setState({ value });
    this.props.onBlur(makeEvent(value));
    this.props.onChange(makeEvent(value));
  }

  onStreetAddressChange(ev) {
    this.updateValue({ ...this.state.value, streetAddress: ev.target.value });
  }

  onCityChange(ev) {
    this.updateValue({ ...this.state.value, city: ev.target.value });
  }

  onStateChange(ev) {
    this.updateValue({ ...this.state.value, state: ev.target.value });
  }

  onCountryChange(ev) {
    this.updateValue({ ...this.state.value, country: ev.target.value });
  }

  onPostalCodeChange(ev) {
    this.updateValue({ ...this.state.value, postalCode: ev.target.value });
  }

  renderStreetAddressInput(streetAddress) {
    return (
      <div className="form-group">
        <label>
          <FormattedMessage
            id="addressInput.streetAddess.label"
            defaultMessage="Street address"
          />
        </label>
        <input
          type="text"
          className="street-address-input form-control"
          onChange={this.onStreetAddressChange}
          value={streetAddress}
        />
      </div>
    );
  }

  renderCityInput(city) {
    return (
      <div className="form-group">
        <label>
          <FormattedMessage
            id="addressInput.city.label"
            defaultMessage="City"
          />
        </label>
        <input
          type="text"
          className="city-input form-control"
          onChange={this.onCityChange}
          value={city}
        />
      </div>
    );
  }

  renderStateInput(state) {
    return (
      <div className="form-group">
        <label>
          <FormattedMessage
            id="addressInput.state.field"
            defaultMessage="State"
          />
        </label>
        <input
          type="text"
          className="state-input form-control"
          onChange={this.onStateChange}
          value={state}
        />
      </div>
    );
  }

  renderCountryInput(country) {
    return (
      <div className="form-group">
        <label>
          <FormattedMessage
            id="streetAddress.country.label"
            defaultMessage="Country"
          />
        </label>
        <input
          type="text"
          className="country-input form-control"
          onChange={this.onCountryChange}
          value={country}
        />
      </div>
    );
  }

  renderPostalCodeInput(postalCode) {
    return (
      <div className="form-group">
        <label>
          <FormattedMessage
            id="addressInput.zip.label"
            defaultMessage="Postal code"
          />
        </label>
        <input
          type="text"
          className="postal-code-input form-control"
          onChange={this.onPostalCodeChange}
          value={postalCode}
        />
      </div>
    );
  }

  render() {
    const className = `address-input ${this.props.className || ''}`;
    const {
      streetAddress,
      city,
      state,
      country,
      postalCode,
    } = this.state.value;

    return (
      <div className={className}>
        {this.renderStreetAddressInput(streetAddress)}
        <div className="row">
          <div className="col-6">
            {this.renderCityInput(city)}
          </div>
          <div className="col-6">
            {this.renderStateInput(state)}
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            {this.renderCountryInput(country)}
          </div>
          <div className="col-6">
            {this.renderPostalCodeInput(postalCode)}
          </div>
        </div>
      </div>
    );
  }
}

AddressInput.defaultProps = {
  onBlur: () => { },
  onChange: () => { },
};

const makeEvent = value => ({
  stopPropagation() { },
  preventDefault() { },
  target: { value },
});

export default AddressInput;



// WEBPACK FOOTER //
// ./src/desktop/components/address-input.js